export default __webpack_public_path__ + "static/media/budget.dcc35f17.svg";